import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit, Optional } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppRoute } from 'app/app-layout/constants/app-route.enum';
import { AuthService } from 'app/core/authentication/services/auth.service';
import { RouterRequest } from 'app/core/browser/models/router-request.model';
import { BrowserService } from 'app/core/browser/services/browser.service';
import { LanguageService } from 'app/core/language/services/language.service';
import { UserInterface } from 'app/core/user/models';
import { EndUserAgreementComponent } from 'app/login/components/end-user-agreement/end-user-agreement.component';
import { validatePasswordStrength } from 'app/shared/utilities/utility-methods.utility';
import { SiteLogoService } from 'app/site-logo/services/site-logo.service';
import { CookieService } from 'ngx-cookie-service';
import { BehaviorSubject, Subject } from 'rxjs';
import { skip, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'cz-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
})
export class PasswordResetComponent implements OnInit, OnDestroy {
  /* variable declaration */
  public languageArray: any;
  public passwordResetGroup: FormGroup;
  public patterntype: boolean = false;
  public password1: FormControl = new FormControl('', Validators.required);
  public password2: FormControl = new FormControl('', [Validators.required]);
  public hidePassword1: boolean = true;
  public hidePassword2: boolean = true;
  public displayPasswordResetForm: boolean = true;
  public displayPasswordSuccess: boolean = false;
  public displayPasswordTokenExpired: boolean = false;
  public readonly language$: BehaviorSubject<{ [key: string]: string }>;
  public logoHref: string;
  public passwordResetByAdmin: boolean = false;
  public fromAdminResetPassword: boolean = false;
  public isSamePassword: boolean = false;
  public isPasswordLength: boolean = false;
  public isPasswordCharacterSet: boolean = false;
  public isPasswordReqired: boolean = false;
  public isResetPasswordError: boolean = false;
  public isUniquePasswordError: boolean = false;
  public uniquePassword: any;
  public isPasswordCharactersReseted: boolean = false;
  public passwordCharacterResetMessage: any;
  public passwordSiteSettingsInfo: any = [];
  public isMinimumCharChanges: boolean = false;
  private readonly destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(private readonly _route: ActivatedRoute,
              private readonly _browserService: BrowserService,
              private readonly _authService: AuthService,
              private readonly _changeDetector: ChangeDetectorRef,
              private readonly _cookieService: CookieService,
              private readonly _translate: TranslateService,
              private readonly _siteLogoService: SiteLogoService,
              private readonly _languageService: LanguageService,
              private dialog: MatDialog,
              private _snackBar: MatSnackBar,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: any = null,
              @Optional() public dialogRef: MatDialogRef<PasswordResetComponent>) {
    this.languageArray = [];
    this.passwordResetGroup = new FormGroup(
      {
        password1: this.password1,
        password2: this.password2,
      },
      {
        validators: PasswordResetComponent.passwordValidator,
      });

    this.language$ = new BehaviorSubject<{ [key: string]: string }>(undefined);
  }

  public passwordPatterns(pattern: any) {
    this.passwordResetGroup.controls.password1.setValidators(Validators.compose([Validators.required, Validators.pattern(pattern)]));
    this.passwordResetGroup.controls.password2.setValidators(Validators.compose([Validators.required, Validators.pattern(pattern)]));
  }
  public updatePassword(): void {
    this.commonBooleanVariableFalse();
    if (this.passwordResetGroup.controls.password1.value.length < this.passwordSiteSettingsInfo.minimumLength
      || this.passwordResetGroup.controls.password2.value.length < this.passwordSiteSettingsInfo.minimumLength) {
      this.isPasswordLength = true;
    }
    if (this.passwordResetGroup.controls.password1.value != this.passwordResetGroup.controls.password2.value) {
      this.isSamePassword = true;
    }
    if (this.passwordResetGroup.invalid) {
      return;
    }
    if (this.isPasswordLength || this.isSamePassword || this.isPasswordCharactersReseted) {
      return;
    }

    this._changeDetector.markForCheck();
    if (!this.data) {
      this._authService.getLoggedInUser()
        .pipe(takeUntil(this.destroy$))
        .subscribe((user: UserInterface) => {
          if (user && user.id) {
            this._authService.passwordUpdate(user.id.toString(), this.password1.value, this.passwordResetByAdmin).subscribe((res: any) => {
              this.showUpdateSuccess();
              this.onNoClick();
              this._changeDetector.markForCheck();

            },                                                                                                              error => {
              this.commonErrorMessages(error);
            });
          }
        });
    } else {// Password Reset From Admin

      // this._authService.passwordUpdate(this.data.userId.toString(), this.password1.value, this.passwordResetByAdmin);
      this._authService.passwordUpdate(this.data.userId.toString(), this.password1.value, this.passwordResetByAdmin).subscribe((res: any) => {
        // Static text to Language Variable updated
        this.onNoClick();
        this.showSnackBar(this._translate.instant('$message_password_reset'));
        
         {
          if (!this.passwordResetByAdmin) {
            this.onNoClick();
            // this.goToDashboard();
            this.goToLogin();
          // this.endUserAgreementDialog();
          } else {
            if (this.data.type !== 'admin') {
              // this.goToDashboard();
              this.goToLogin();
              this.onNoClick();
            }
          }
        }
      },                                                                                                                       error => {
        this.commonErrorMessages(error);
      });
    }

  }
  public commonErrorMessages(error: any) {
    if (error.error.message === 'Password Already Used') {
      this.isUniquePasswordError = true;
      this.uniquePassword = this.passwordResetGroup.controls.password1.value;
    } else if (error.error.message !== 'Valid') {
      this.isPasswordCharactersReseted = true;
      this.passwordCharacterResetMessage = error.error.message;
    }
    this._changeDetector.markForCheck();
  }

  public commonBooleanVariableFalse(): void {
    this.isSamePassword = false;
    this.isPasswordLength = false;
    this.isPasswordCharacterSet = false;
    this.isResetPasswordError = false;
    this.isUniquePasswordError = false;
    this.isPasswordCharactersReseted = false;
    this.patterntype = false;
    this.isMinimumCharChanges = false;
  }

  public goToLogin(): void {
    const navRequest: RouterRequest = new RouterRequest({ route: AppRoute.login });
    this._browserService.to(navRequest);
  }

  public goToResetPassword(): void {
    const navRequest: RouterRequest = new RouterRequest({ route: AppRoute.login, queryParams: { resetPassword: true } });
    this._browserService.to(navRequest);
  }

  public showUpdateSuccess(): void {
    this.displayPasswordResetForm = false;
    this.displayPasswordSuccess = true;
    this._changeDetector.markForCheck();
  }

  public showTokenExpired(): void {
    this.displayPasswordResetForm = false;
    this.displayPasswordTokenExpired = true;
    this._changeDetector.markForCheck();
  }

  public ngOnInit(): void {
    if (!this.data) {
      const userId: string = this._route.snapshot.queryParamMap.get('userid');
      const token: string = this._route.snapshot.queryParamMap.get('token');

      this._authService.validatePasswordResetToken(userId, token)
        .pipe(
          skip(1),
          takeUntil(this.destroy$))
        .subscribe((canResetPassword: boolean) => {
          if (canResetPassword === undefined) {
            return;
          }
          if (!canResetPassword) {
            this.showTokenExpired();
          }
        });



    } else {
      this.passwordResetByAdmin = (this.data.type !== 'admin') ? false : true;
      /*hide footer for reset pwd from admin*/
      this.fromAdminResetPassword = true;
    }

    this._languageService.getLanguages()
      .pipe(takeUntil(this.destroy$))
      .subscribe((language: { [key: string]: string }) => {
        // Assign llanguage data
        this.languageArray = Object.values(language);
        if (typeof language === 'undefined' || Object.keys(language).length === 0) { return; }

        let cultureCookie: string = this._cookieService.get('Culture');

        const languageKey: any = this.languageArray.find((item: any) => item.culture === cultureCookie);
        // Udating default language as cookie if cookie value exist in languageArray
        if (typeof languageKey === 'undefined' || languageKey.length === 0) {
          this.languageArray.map((item: any) => {
            if (item.isDefault) {
              this._cookieService.delete('Culture', undefined, '/');
              this._cookieService.set('Culture', item.culture, undefined, '/');
              cultureCookie = item.culture;
            }
          });
        }


        // add language keys to translation service
        if (this._translate.getLangs().length < 1) {
          const langArr: string[] = this.languageArray.map((item: any) => item.culture); // Object.keys(language);
          this._translate.addLangs(langArr);
        }
        // set default language to culture cookie language and use it
        this._translate.setDefaultLang(cultureCookie);
        this._translate.use(cultureCookie);

        this.language$.next(language);
      });

    this._siteLogoService.loadSiteLogo()
      .pipe(takeUntil(this.destroy$))
      .subscribe((href: string) => {
        if (!href) { return; }
        this.logoHref = href;
      });
    this._authService.getPasswordSettingsData().subscribe((res: any) => {
      this.passwordSiteSettingsInfo = res;
      if (res.requiredCharacterSets != '') {
        const str = this.passwordSiteSettingsInfo.requiredCharacterSets;
        const spericalChars = '!@#\$%\^\&*\)\(+=._-';
        const arr = str.split(',');
        let regex = '';
        for (let i = 0; i < arr.length; i++) {
          if (arr[i] == 'special') {
            regex += '(?=.*[' + spericalChars + '])';
          } else {
            regex += '(?=.*[' + arr[i] + '])';
          }
        }
        // let regex = "(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[!@#$%^&*)(+=._-])";

        const finalRegex = new RegExp(regex);
        this.passwordPatterns(finalRegex);
      } else {
        this.passwordResetGroup.controls.password1.clearValidators();
        this.passwordResetGroup.controls.password2.clearValidators();
        this.passwordResetGroup.controls.password1.setValidators(Validators.required);
        this.passwordResetGroup.controls.password2.setValidators(Validators.required);
      }
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }


  public logout(): void {
    this.dialogRef.close();
    const navRequest: RouterRequest = new RouterRequest({ route: AppRoute.logout });
    this._browserService.to(navRequest);
  }
  public endUserAgreementDialog(): void {
    this.dialog.open(EndUserAgreementComponent, {
      height: '480px',
      width: '700px',
      data: {
        username: this.data.username,
        password: this.data.password,
      },
    });
  }

  private static passwordValidator(ac: AbstractControl): ValidationErrors {
    const password1: string = ac.value['password1'];
    const password2: string = ac.value['password2'];

    const match: boolean = password1 === password2;

    if (!match) {
      // ac.get('password2').setErrors({ noMatch: true });
    } else if (!validatePasswordStrength(password1)) {
      // ac.get('password1').setErrors({ notStrong: true });
    } else {
      ac.get('password2').setErrors(null);
    }
    return ac.get('password2').errors;
  }

  /**
   * generic snack bar notifier to notify users of specific events
   * @param message message to display in snackbar
   */
  private showSnackBar(message: string): void {
    this._snackBar.open(message, undefined, {
      duration: 5000,
    });
  }

  private onNoClick(): void {
    this.dialogRef.close();
  }



  private goToDashboard(): void {
    const navRequest: RouterRequest = new RouterRequest({ route: AppRoute.myZone });
    this._browserService.to(navRequest);
  }

}
